// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Styles */

.dashboard-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background-color: var(--bg-primary);
  width: 100%;
  max-width: 100%;
}

/* RobiTest shell — top bar is inside the grid; do not reserve old navbar space */
.dashboard-container.rt2-dashboard {
  padding-top: 0;
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
  overflow: visible;
  background: transparent;
}

.dashboard-content {
  flex: 1 1;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow: visible;
  height: auto;
  box-sizing: border-box;
}

.dashboard-welcome {
  margin-bottom: 2rem;
  text-align: center;
}

.dashboard-welcome h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.dashboard-welcome p {
  font-size: 1.1rem;
  color: var(--text-muted);
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13%, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.dashboard-card {
  background-color: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 120px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.dashboard-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.dashboard-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
}

.card-stat {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-color);
  min-width: 100px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.recent-activity {
  background-color: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.recent-activity h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.activity-list {
  list-style: none;
  padding: 0;
}

.activity-item {
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  border-bottom: 1px solid var(--border-color-light);
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-time {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.activity-description {
  font-size: 0.95rem;
  color: var(--text-dark);
}

.btn-outline {
  background-color: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background-color: var(--primary-color);
  color: white;
}

@media (max-width: 768px) {
  /* 
  .dashboard-header {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .user-menu {
    margin-top: 1rem;
    width: 100%;
    justify-content: space-between;
  }
  */
  
  .dashboard-content {
    padding: 1rem;
  }
  
  .dashboard-cards {
    grid-template-columns: 1fr;
  }
}

.oneThird {
  width: calc(40% - 0.75rem);
}

.twoThirds{
  width: calc(60% - 0.75rem);  
}

@media (max-width: 1200px) {
  .halfWidth {
    grid-column: span 12;
  }
  
  .oneThird {
    grid-column: span 6;
  }
  
  .twoThirds {
    grid-column: span 12;
  }
  
  .quarterWidth {
    grid-column: span 6;
  }
}

@media (max-width: 768px) {
  .statsContainer {
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-sm);
  }
  
  .oneThird, .quarterWidth {
    grid-column: span 12;
  }
  
  .recentProjects {
    padding: var(--spacing-sm);
  }
  
  .projectsTable th, 
  .projectsTable td {
    padding: 0.5rem;
    font-size: 0.75rem;
  }
}

/* Section Titles */
.sectionTitle {
  color: var(--color-neutral-black);
  font-size: 1.125rem;
  margin-top: 0;
  margin-bottom: var(--spacing-md);
  font-weight: 600;
  position: relative;
  padding-bottom: var(--spacing-xs);
}

.sectionTitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: var(--color-primary-main);
  border-radius: var(--border-radius-full);
}

/* Chart Container */
.chartContainer {
  position: relative;
  height: 100%;
  min-height: 300px;
  background-color: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 1.5rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* Prevent content overflow */
}

.summaryCard {
  background: var(--color-neutral-white);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  box-shadow: var(--shadow-sm);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.summaryCardHeader {
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-sm);
}

.summaryCardIcon {
  width: 48px;
  height: 48px;
  border-radius: var(--border-radius-sm);
  background: rgba(54, 162, 235, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-sm);
  color: var(--color-primary-main);
  font-size: 24px;
  flex-shrink: 0;
}

.summaryCardTitle {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-neutral-medium);
}

.summaryCardValue {
  font-size: 1.75rem;
  font-weight: 700;
  margin: var(--spacing-xs) 0;
  color: var(--color-neutral-dark);
}

.summaryCardChange {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: var(--spacing-xs);
}

.summaryCardChange.increase {
  color: var(--color-success-main);
}

.summaryCardChange.decrease {
  color: var(--color-error-main);
}

.summaryCardDescription {
  font-size: 0.75rem;
  color: var(--color-neutral-medium);
  margin-top: auto;
}

.dashboardGrid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-xl);
}

/* Responsive summary cards grid */
.summary-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 1.5rem;
  width: 100%;
  max-width: 100%;
}

/* Responsive charts grid */
.charts-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  width: 100%;
  max-width: 100%;
}

@media (max-width: 1200px) {
  .summary-cards-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }
}

@media (max-width: 1024px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .summary-cards-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .summary-cards-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
  }
  
  .dashboard-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .summary-cards-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
/* Welcome Banner Styles */
.welcome-banner {
  background: linear-gradient(135deg, #4361ee 0%, #4cc9f0 100%);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.2);
  animation: slideInDown 0.5s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.welcome-banner-content {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  color: white;
}

.welcome-banner-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.welcome-banner-text {
  flex: 1 1;
}

.welcome-banner-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  color: white;
}

.welcome-banner-message {
  font-size: 1rem;
  margin: 0;
  opacity: 0.95;
  line-height: 1.5;
}

.welcome-banner-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-shrink: 0;
}

.welcome-banner-btn {
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.welcome-banner-btn.primary {
  background: white;
  color: #4361ee;
}

.welcome-banner-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.welcome-banner-btn.secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.welcome-banner-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.3);
}

.welcome-banner-btn-close {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.welcome-banner-btn-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

@media (max-width: 768px) {
  .welcome-banner-content {
    flex-direction: column;
    text-align: center;
  }

  .welcome-banner-actions {
    flex-direction: column;
    width: 100%;
  }

  .welcome-banner-btn {
    width: 100%;
  }

  .welcome-banner-btn-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
}


/* Workspace Home */
.rt-wh-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  padding: 20px 22px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  background:
    radial-gradient(120% 140% at 100% 0%, var(--rt-primary-subtle) 0%, transparent 55%),
    var(--rt-surface);
}

.rt-wh-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border: 1px solid var(--rt-primary-border);
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-primary);
  background: var(--rt-primary-subtle);
}

.rt-wh-hero__title {
  margin: 10px 0 0;
  font-size: 1.375rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--rt-text);
}

.rt-wh-hero__desc {
  margin: 4px 0 0;
  max-width: 60ch;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-muted);
}

.rt-wh-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.rt-wh-hero__actions .rt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Charts */
.rt-wh-charts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 14px;
  align-items: stretch;
}

.rt-wh-charts--lead {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.6fr);
  margin-top: 16px;
}

.rt-wh-charts .rt2-panel {
  display: flex;
  flex-direction: column;
}

.rt-wh-charts .rt2-panel__body {
  flex: 1 1;
}

.rt-wh-donut {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
}

.rt-wh-donut__canvas {
  height: 220px;
  position: relative;
}

.rt-wh-legend {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-secondary);
}

.rt-wh-legend li {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 8px;
}

.rt-wh-legend strong {
  color: var(--rt-text);
  font-variant-numeric: tabular-nums;
}

.rt-wh-legend .rt2-muted {
  min-width: 34px;
  text-align: right;
}

.rt-wh-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
  margin-top: 16px;
  align-items: start;
}

/* Projects panel */
.rt-wh-projects__header {
  flex-wrap: wrap;
}

.rt-wh-count {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  color: var(--rt-text-muted);
  background: var(--rt-surface-hover);
  vertical-align: middle;
}

.rt-wh-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rt-wh-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md);
  background: var(--rt-bg);
  color: var(--rt-text-muted);
}

.rt-wh-search:focus-within {
  border-color: var(--rt-primary-border);
  box-shadow: 0 0 0 3px var(--rt-primary-subtle);
}

.rt-wh-search input {
  width: 180px;
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  font-size: var(--rt-text-sm);
  color: var(--rt-text);
}

.rt-wh-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--rt-border-subtle);
}

.rt-wh-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--rt-border);
  border-radius: 999px;
  background: transparent;
  font: inherit;
  font-size: var(--rt-text-xs);
  font-weight: 600;
  color: var(--rt-text-secondary);
  cursor: pointer;
  transition: background var(--rt-transition), border-color var(--rt-transition);
}

.rt-wh-chip:hover {
  background: var(--rt-surface-hover);
}

.rt-wh-chip--active {
  border-color: var(--rt-primary-border);
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
}

.rt-wh-chip__count {
  font-weight: 500;
  color: var(--rt-text-muted);
}

.rt-wh-row {
  cursor: pointer;
}

.rt-wh-desc {
  max-width: 42ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-wh-num {
  font-variant-numeric: tabular-nums;
}

.rt-wh-open {
  width: 28px;
  color: var(--rt-text-muted);
  opacity: 0;
  transition: opacity var(--rt-transition), transform var(--rt-transition);
}

.rt-wh-row:hover .rt-wh-open {
  opacity: 1;
  transform: translateX(2px);
  color: var(--rt-primary);
}

/* Jump back in */
.rt-wh-continue {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px;
  border: 1px solid var(--rt-primary-border);
  border-radius: var(--rt-radius-lg);
  background: var(--rt-primary-subtle);
  font: inherit;
  text-align: left;
  color: var(--rt-text);
  cursor: pointer;
  transition: transform var(--rt-transition);
}

.rt-wh-continue:hover {
  transform: translateY(-1px);
}

.rt-wh-continue__icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: var(--rt-radius-md);
  background: var(--rt-primary);
  color: #fff;
}

.rt-wh-continue__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rt-wh-continue__text strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--rt-text-base);
}

.rt-wh-continue__arrow {
  margin-left: auto;
  flex-shrink: 0;
  color: var(--rt-primary);
}

/* Workspace overview additions */
.rt-wh > * + * {
  margin-top: 16px;
}

.rt-wh .rt-wh-charts,
.rt-wh .rt-wh-continue {
  margin-top: 16px;
}

.rt-wh-charts--three {
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr);
}

.rt-wh-kpis {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.rt-wh .rt-metric-card--danger {
  border-color: color-mix(in srgb, var(--rt-danger) 45%, var(--rt-border));
}

.rt-wh-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 16px;
  padding: 12px 14px;
  border: 1px solid var(--rt-border);
  border-radius: 12px;
  background: var(--rt-surface);
}

.rt-wh-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.rt-wh-filter__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--rt-text-xs);
  font-weight: 600;
  color: var(--rt-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.rt-wh-filter__select {
  min-width: 200px;
  max-width: 280px;
  height: 34px;
  padding: 0 30px 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: 8px;
  background-color: var(--rt-surface);
  color: var(--rt-text);
  font: inherit;
  font-size: var(--rt-text-sm);
  cursor: pointer;
}

.rt-wh-filter__select:focus-visible {
  outline: 2px solid var(--rt-primary);
  outline-offset: 1px;
}

.rt-wh-filter__select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.rt-wh-filters__end {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.rt-wh-ws-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border-radius: 999px;
  background: var(--rt-surface-muted, var(--rt-bg-subtle));
  color: var(--rt-text-secondary);
  font-size: 11px;
  white-space: nowrap;
}

.rt-wh-updated {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.rt-wh-refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--rt-text-muted);
  cursor: pointer;
}

.rt-wh-refresh:hover:not(:disabled) {
  background: var(--rt-surface-muted, var(--rt-bg-subtle));
  color: var(--rt-text);
}

.rt-wh-spin {
  animation: rt-wh-spin 900ms linear infinite;
}

@keyframes rt-wh-spin {
  to {
    transform: rotate(360deg);
  }
}

.rt-wh-delta {
  display: block;
  font-size: var(--rt-text-xs);
  font-weight: 500;
}

.rt-wh-project-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  min-width: 0;
}

.rt-wh-auto {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 110px;
}

.rt-wh-auto .pqd-progress {
  flex: 1 1;
}

.rt-wh-lastrun {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
}

.rt-wh-lastrun__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.rt-wh-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.rt-wh-list li + li {
  border-top: 1px solid var(--rt-border);
}

.rt-wh-list__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 4px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: 6px;
}

.rt-wh-list__item:hover {
  background: var(--rt-surface-muted, var(--rt-bg-subtle));
}

.rt-wh-list__item:focus-visible {
  outline: 2px solid var(--rt-primary);
  outline-offset: 1px;
}

.rt-wh-list__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.rt-wh-list__side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .rt-wh-charts,
  .rt-wh-charts--lead,
  .rt-wh-charts--three {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rt-wh-spin {
    animation: none;
  }
}

@media (max-width: 720px) {
  .rt-wh-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .rt-wh-search input {
    width: 120px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rt-wh-continue,
  .rt-wh-open {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,qDAAqD;EACrD,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE;;;;;;;;;;;;GAYC;;EAED;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,qDAAqD;EACrD,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;AACA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;AACF;;;AAGA,mBAAmB;AACnB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC;;qBAEmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;EAClC,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,wDAAwD;EACxD,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Dashboard Styles */\n\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background-color: var(--bg-primary);\n  width: 100%;\n  max-width: 100%;\n}\n\n/* RobiTest shell — top bar is inside the grid; do not reserve old navbar space */\n.dashboard-container.rt2-dashboard {\n  padding-top: 0;\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 0;\n  overflow: visible;\n  background: transparent;\n}\n\n.dashboard-content {\n  flex: 1;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow: visible;\n  height: auto;\n  box-sizing: border-box;\n}\n\n.dashboard-welcome {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.dashboard-welcome h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-welcome p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n}\n\n.dashboard-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(13%, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.dashboard-card {\n  background-color: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  min-height: 120px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.dashboard-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-card h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-card p {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  margin-bottom: 1rem;\n}\n\n.card-stat {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--primary-color);\n  min-width: 100px;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.recent-activity {\n  background-color: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.recent-activity h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.activity-list {\n  list-style: none;\n  padding: 0;\n}\n\n.activity-item {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n.activity-item:last-child {\n  border-bottom: none;\n}\n\n.activity-time {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.activity-description {\n  font-size: 0.95rem;\n  color: var(--text-dark);\n}\n\n.btn-outline {\n  background-color: transparent;\n  border: 1px solid var(--primary-color);\n  color: var(--primary-color);\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-outline:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n@media (max-width: 768px) {\n  /* \n  .dashboard-header {\n    padding: 1rem;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .user-menu {\n    margin-top: 1rem;\n    width: 100%;\n    justify-content: space-between;\n  }\n  */\n  \n  .dashboard-content {\n    padding: 1rem;\n  }\n  \n  .dashboard-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.oneThird {\n  width: calc(40% - 0.75rem);\n}\n\n.twoThirds{\n  width: calc(60% - 0.75rem);  \n}\n\n@media (max-width: 1200px) {\n  .halfWidth {\n    grid-column: span 12;\n  }\n  \n  .oneThird {\n    grid-column: span 6;\n  }\n  \n  .twoThirds {\n    grid-column: span 12;\n  }\n  \n  .quarterWidth {\n    grid-column: span 6;\n  }\n}\n\n@media (max-width: 768px) {\n  .statsContainer {\n    grid-template-columns: 1fr 1fr;\n    gap: var(--spacing-sm);\n  }\n  \n  .oneThird, .quarterWidth {\n    grid-column: span 12;\n  }\n  \n  .recentProjects {\n    padding: var(--spacing-sm);\n  }\n  \n  .projectsTable th, \n  .projectsTable td {\n    padding: 0.5rem;\n    font-size: 0.75rem;\n  }\n}\n\n/* Section Titles */\n.sectionTitle {\n  color: var(--color-neutral-black);\n  font-size: 1.125rem;\n  margin-top: 0;\n  margin-bottom: var(--spacing-md);\n  font-weight: 600;\n  position: relative;\n  padding-bottom: var(--spacing-xs);\n}\n\n.sectionTitle::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 30px;\n  height: 2px;\n  background: var(--color-primary-main);\n  border-radius: var(--border-radius-full);\n}\n\n/* Chart Container */\n.chartContainer {\n  position: relative;\n  height: 100%;\n  min-height: 300px;\n  background-color: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  margin-bottom: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden; /* Prevent content overflow */\n}\n\n.summaryCard {\n  background: var(--color-neutral-white);\n  border-radius: var(--border-radius-md);\n  padding: var(--spacing-md);\n  box-shadow: var(--shadow-sm);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.summaryCardHeader {\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--spacing-sm);\n}\n\n.summaryCardIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--border-radius-sm);\n  background: rgba(54, 162, 235, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: var(--spacing-sm);\n  color: var(--color-primary-main);\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.summaryCardTitle {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-neutral-medium);\n}\n\n.summaryCardValue {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: var(--spacing-xs) 0;\n  color: var(--color-neutral-dark);\n}\n\n.summaryCardChange {\n  display: flex;\n  align-items: center;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-bottom: var(--spacing-xs);\n}\n\n.summaryCardChange.increase {\n  color: var(--color-success-main);\n}\n\n.summaryCardChange.decrease {\n  color: var(--color-error-main);\n}\n\n.summaryCardDescription {\n  font-size: 0.75rem;\n  color: var(--color-neutral-medium);\n  margin-top: auto;\n}\n\n.dashboardGrid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-xl);\n}\n\n/* Responsive summary cards grid */\n.summary-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Responsive charts grid */\n.charts-grid {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n@media (max-width: 1200px) {\n  .summary-cards-grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  }\n}\n\n@media (max-width: 1024px) {\n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .summary-cards-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .summary-cards-grid {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 12px;\n  }\n  \n  .dashboard-content {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .summary-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n/* Welcome Banner Styles */\n.welcome-banner {\n  background: linear-gradient(135deg, #4361ee 0%, #4cc9f0 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.2);\n  animation: slideInDown 0.5s ease-out;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.welcome-banner-content {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  color: white;\n}\n\n.welcome-banner-icon {\n  font-size: 3rem;\n  flex-shrink: 0;\n}\n\n.welcome-banner-text {\n  flex: 1;\n}\n\n.welcome-banner-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  color: white;\n}\n\n.welcome-banner-message {\n  font-size: 1rem;\n  margin: 0;\n  opacity: 0.95;\n  line-height: 1.5;\n}\n\n.welcome-banner-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.welcome-banner-btn {\n  padding: 0.625rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.welcome-banner-btn.primary {\n  background: white;\n  color: #4361ee;\n}\n\n.welcome-banner-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.welcome-banner-btn.secondary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.welcome-banner-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.welcome-banner-btn-close {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.welcome-banner-btn-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: rotate(90deg);\n}\n\n@media (max-width: 768px) {\n  .welcome-banner-content {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .welcome-banner-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .welcome-banner-btn {\n    width: 100%;\n  }\n\n  .welcome-banner-btn-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n  }\n}\n\n\n/* Workspace Home */\n.rt-wh-hero {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  padding: 20px 22px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  background:\n    radial-gradient(120% 140% at 100% 0%, var(--rt-primary-subtle) 0%, transparent 55%),\n    var(--rt-surface);\n}\n\n.rt-wh-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 8px;\n  border: 1px solid var(--rt-primary-border);\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-primary);\n  background: var(--rt-primary-subtle);\n}\n\n.rt-wh-hero__title {\n  margin: 10px 0 0;\n  font-size: 1.375rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--rt-text);\n}\n\n.rt-wh-hero__desc {\n  margin: 4px 0 0;\n  max-width: 60ch;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-muted);\n}\n\n.rt-wh-hero__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.rt-wh-hero__actions .rt-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Charts */\n.rt-wh-charts {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  margin-top: 14px;\n  align-items: stretch;\n}\n\n.rt-wh-charts--lead {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.6fr);\n  margin-top: 16px;\n}\n\n.rt-wh-charts .rt2-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.rt-wh-charts .rt2-panel__body {\n  flex: 1;\n}\n\n.rt-wh-donut {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 16px;\n  align-items: center;\n}\n\n.rt-wh-donut__canvas {\n  height: 220px;\n  position: relative;\n}\n\n.rt-wh-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-secondary);\n}\n\n.rt-wh-legend li {\n  display: grid;\n  grid-template-columns: auto 1fr auto auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.rt-wh-legend strong {\n  color: var(--rt-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-wh-legend .rt2-muted {\n  min-width: 34px;\n  text-align: right;\n}\n\n.rt-wh-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 14px;\n  margin-top: 16px;\n  align-items: start;\n}\n\n/* Projects panel */\n.rt-wh-projects__header {\n  flex-wrap: wrap;\n}\n\n.rt-wh-count {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--rt-text-muted);\n  background: var(--rt-surface-hover);\n  vertical-align: middle;\n}\n\n.rt-wh-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.rt-wh-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-bg);\n  color: var(--rt-text-muted);\n}\n\n.rt-wh-search:focus-within {\n  border-color: var(--rt-primary-border);\n  box-shadow: 0 0 0 3px var(--rt-primary-subtle);\n}\n\n.rt-wh-search input {\n  width: 180px;\n  border: none;\n  outline: none;\n  background: transparent;\n  font: inherit;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text);\n}\n\n.rt-wh-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n}\n\n.rt-wh-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: 999px;\n  background: transparent;\n  font: inherit;\n  font-size: var(--rt-text-xs);\n  font-weight: 600;\n  color: var(--rt-text-secondary);\n  cursor: pointer;\n  transition: background var(--rt-transition), border-color var(--rt-transition);\n}\n\n.rt-wh-chip:hover {\n  background: var(--rt-surface-hover);\n}\n\n.rt-wh-chip--active {\n  border-color: var(--rt-primary-border);\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n}\n\n.rt-wh-chip__count {\n  font-weight: 500;\n  color: var(--rt-text-muted);\n}\n\n.rt-wh-row {\n  cursor: pointer;\n}\n\n.rt-wh-desc {\n  max-width: 42ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-wh-num {\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-wh-open {\n  width: 28px;\n  color: var(--rt-text-muted);\n  opacity: 0;\n  transition: opacity var(--rt-transition), transform var(--rt-transition);\n}\n\n.rt-wh-row:hover .rt-wh-open {\n  opacity: 1;\n  transform: translateX(2px);\n  color: var(--rt-primary);\n}\n\n/* Jump back in */\n.rt-wh-continue {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--rt-primary-border);\n  border-radius: var(--rt-radius-lg);\n  background: var(--rt-primary-subtle);\n  font: inherit;\n  text-align: left;\n  color: var(--rt-text);\n  cursor: pointer;\n  transition: transform var(--rt-transition);\n}\n\n.rt-wh-continue:hover {\n  transform: translateY(-1px);\n}\n\n.rt-wh-continue__icon {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-primary);\n  color: #fff;\n}\n\n.rt-wh-continue__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rt-wh-continue__text strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--rt-text-base);\n}\n\n.rt-wh-continue__arrow {\n  margin-left: auto;\n  flex-shrink: 0;\n  color: var(--rt-primary);\n}\n\n/* Workspace overview additions */\n.rt-wh > * + * {\n  margin-top: 16px;\n}\n\n.rt-wh .rt-wh-charts,\n.rt-wh .rt-wh-continue {\n  margin-top: 16px;\n}\n\n.rt-wh-charts--three {\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr);\n}\n\n.rt-wh-kpis {\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n}\n\n.rt-wh .rt-metric-card--danger {\n  border-color: color-mix(in srgb, var(--rt-danger) 45%, var(--rt-border));\n}\n\n.rt-wh-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px 16px;\n  padding: 12px 14px;\n  border: 1px solid var(--rt-border);\n  border-radius: 12px;\n  background: var(--rt-surface);\n}\n\n.rt-wh-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.rt-wh-filter__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--rt-text-xs);\n  font-weight: 600;\n  color: var(--rt-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.rt-wh-filter__select {\n  min-width: 200px;\n  max-width: 280px;\n  height: 34px;\n  padding: 0 30px 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: 8px;\n  background-color: var(--rt-surface);\n  color: var(--rt-text);\n  font: inherit;\n  font-size: var(--rt-text-sm);\n  cursor: pointer;\n}\n\n.rt-wh-filter__select:focus-visible {\n  outline: 2px solid var(--rt-primary);\n  outline-offset: 1px;\n}\n\n.rt-wh-filter__select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.rt-wh-filters__end {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.rt-wh-ws-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: var(--rt-surface-muted, var(--rt-bg-subtle));\n  color: var(--rt-text-secondary);\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.rt-wh-updated {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.rt-wh-refresh {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--rt-text-muted);\n  cursor: pointer;\n}\n\n.rt-wh-refresh:hover:not(:disabled) {\n  background: var(--rt-surface-muted, var(--rt-bg-subtle));\n  color: var(--rt-text);\n}\n\n.rt-wh-spin {\n  animation: rt-wh-spin 900ms linear infinite;\n}\n\n@keyframes rt-wh-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rt-wh-delta {\n  display: block;\n  font-size: var(--rt-text-xs);\n  font-weight: 500;\n}\n\n.rt-wh-project-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  min-width: 0;\n}\n\n.rt-wh-auto {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 110px;\n}\n\n.rt-wh-auto .pqd-progress {\n  flex: 1;\n}\n\n.rt-wh-lastrun {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 220px;\n}\n\n.rt-wh-lastrun__text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.rt-wh-list {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.rt-wh-list li + li {\n  border-top: 1px solid var(--rt-border);\n}\n\n.rt-wh-list__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 4px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.rt-wh-list__item:hover {\n  background: var(--rt-surface-muted, var(--rt-bg-subtle));\n}\n\n.rt-wh-list__item:focus-visible {\n  outline: 2px solid var(--rt-primary);\n  outline-offset: 1px;\n}\n\n.rt-wh-list__main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.rt-wh-list__side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 1100px) {\n  .rt-wh-charts,\n  .rt-wh-charts--lead,\n  .rt-wh-charts--three {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-wh-spin {\n    animation: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .rt-wh-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .rt-wh-search input {\n    width: 120px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-wh-continue,\n  .rt-wh-open {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
